import {useEffect, useState} from 'react'
import {MenuComponent} from '../../../../../../../../_metronic/assets/ts/components'
import {initialQueryState, KTSVG} from '../../../../../../../../_metronic/helpers'
import {useQueryRequest} from '../../core/QueryRequestProvider'
import {useIntl} from 'react-intl'
import axios from 'axios'
import AsyncSelect from 'react-select/async'
import {colourStyles} from '../..//..//styles//styles'
import makeAnimated from 'react-select/animated'
import moment from 'moment'
import {Calendar} from 'primereact/calendar'
import {AnimaCima2} from '../../../../../../../../_metronic/assets/animation/styles'
import {insertDataTime} from '../../../../../../../../util/insertDataTime'

interface props {
  data?: any
  onDataFromChild: (data: any) => void
}

const LicensesListFilter: React.FC<props> = ({data, onDataFromChild}) => {
  //const LicensesListFilter = (data: any, onDataFromChild: (data2: any) => void) => {
  const {updateState} = useQueryRequest()
  const intl = useIntl()

  //estado inicial do select
  const initSelect = {
    value: '',
    label: intl.formatMessage({id: 'COMMON.ALL'}),
  }

  const animatedComponents = makeAnimated()
  const [openFilterWin, setOpenFilterWin] = useState<boolean>(false)
  const [openDatelimit, setOpenDatelimit] = useState<boolean>(false)
  const [openDateexp, setOpenDateexp] = useState<boolean>(false)
  const [openDateemi, setOpenDateemi] = useState<boolean>(false)

  const [project_obj, setproject_obj] = useState<any | undefined>()
  const [project_id, setproject_id] = useState<string | undefined>()

  const [entrepreneur_id_obj, setentrepreneur_id_obj] = useState<any | undefined>()
  const [entrepreneur_id, setentrepreneur_id] = useState<string | undefined>()

  const [enterprise_type_id_obj, setenterprise_type_id_obj] = useState<any | undefined>()
  const [enterprise_type_id, setenterprise_type_id] = useState<string | undefined>()

  const [enterprise_id, setenterprise_id] = useState<string | undefined>()
  const [enterprise_id_obj, setenterprise_id_obj] = useState<any | undefined>()

  const [license_type_id_obj, setlicense_type_id_obj] = useState<any | undefined>()
  const [license_type_id, setlicense_type_id] = useState<string | undefined>()

  const [field_id_obj, setfield_id_obj] = useState<any | undefined>()
  const [field_id, setfield_id] = useState<[string] | undefined>()

  const [license_number, setlicense_number] = useState<string | undefined>()
  const [description, setdescription] = useState<string | undefined>()
  const [renovation_protocol, setrenovation_protocol] = useState<string | undefined>()
  const [status, setstatus] = useState<string | undefined>()

  const [issue_date, setissue_date] = useState<Date | Date[] | undefined>(undefined)
  const [issue_dateD, setissue_dateD] = useState<Date | Date[] | undefined>(undefined)

  const [issue_date_between, setissue_date_between] = useState<Date | Date[] | undefined>(undefined)
  const [issue_date_betweenD, setissue_date_betweenD] = useState<Date | Date[] | undefined>(
    undefined
  )

  const [expiration_date, setexpiration_date] = useState<Date | Date[] | undefined>(undefined)
  const [expiration_date_dateD, setexpiration_date_dateD] = useState<Date | Date[] | undefined>(
    undefined
  )

  const [expiration_date_between, setexpiration_date_between] = useState<Date | Date[] | undefined>(
    undefined
  )
  const [expiration_date_betweenD, setexpiration_date_betweenD] = useState<
    Date | Date[] | undefined
  >(undefined)

  const [limit_renovation, setlimit_renovation] = useState<Date | Date[] | undefined>(undefined)
  const [limit_renovationD, setlimit_renovationD] = useState<Date | Date[] | undefined>(undefined)

  const [limit_renovation_between, setlimit_renovation_between] = useState<
    Date | Date[] | undefined
  >(undefined)
  const [limit_renovation_betweenD, setlimit_renovation_betweenD] = useState<
    Date | Date[] | undefined
  >(undefined)

  const API_URL = process.env.REACT_APP_API_URL || 'api'

  interface UseOption {
    readonly value: string
    readonly label: string
    readonly color: string
    readonly isFixed?: boolean
    readonly isDisabled?: boolean
  }

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  //inicio de variaveis de do filtro anterior
  const [projectArray, setprojectArray] = useState<any>([])
  const [entrepreneurArray, setentrepreneurArray] = useState<any>([])
  const [enterpriseTypeArray, setenterpriseTypeArray] = useState<any>([])

  useEffect(() => {
    if (data.project_id === '' && data.entrepreneur_id === '' && data.enterprise_type_id === '') {
      resetData()
    } else {
      getProjectFilter1()
    }
  }, [data])

  const getProjectFilter1 = async () => {
    if (data) {
      if (data.project_id) {
        await projectArray.map((item: any) => {
          if (item.value === parseInt(data.project_id)) {
            setproject_id(item.value)
            setproject_obj(item)
          }
        })
      }
      if (data.entrepreneur_id) {
        await entrepreneurArray.map((item: any) => {
          if (item.value === parseInt(data.entrepreneur_id)) {
            setentrepreneur_id(item.value)
            setentrepreneur_id_obj(item)
          }
        })
      }
      if (data.enterprise_type_id) {
        await enterpriseTypeArray.map((item: any) => {
          if (item.value === parseInt(data.enterprise_type_id)) {
            setenterprise_type_id(item.value)
            setenterprise_type_id_obj(item)
          }
        })
      }

      updateState({
        filter: {
          project_id: data.project_id,
          entrepreneur_id: data.entrepreneur_id,
          enterprise_type_id: data.enterprise_type_id,
        },
      })
    }
  }

  const resetData = () => {
    // onDataFromChild({
    //   project_id: '',
    //   entrepreneur_id: '',
    //   enterprise_type_id: '',
    // })
    updateState({filter: undefined, ...initialQueryState})
    setproject_id(undefined)
    setproject_obj(initSelect)

    setenterprise_id(undefined)
    setenterprise_id_obj(initSelect)

    setlicense_type_id(undefined)
    setlicense_type_id_obj(initSelect)

    setfield_id(undefined)
    setfield_id_obj([])

    setentrepreneur_id(undefined)
    setentrepreneur_id_obj(initSelect)

    setenterprise_type_id(undefined)
    setenterprise_type_id_obj(initSelect)

    setlicense_number(undefined)
    setdescription(undefined)
    setissue_date(undefined)
    setissue_dateD(undefined)
    setissue_date_between(undefined)
    setissue_date_betweenD(undefined)
    setlimit_renovation(undefined)
    setlimit_renovationD(undefined)
    setlimit_renovation_between(undefined)
    setlimit_renovation_betweenD(undefined)
    setexpiration_date(undefined)
    setexpiration_date_dateD(undefined)
    setexpiration_date_between(undefined)
    setexpiration_date_betweenD(undefined)
    setdescription('')
    setrenovation_protocol('')
    setlicense_number('')
    setstatus('all_relevant')
  }

  const filterData = () => {
    onDataFromChild({
      project_id: project_id !== undefined ? project_id : '',
      entrepreneur_id: entrepreneur_id !== undefined ? entrepreneur_id : '',
      enterprise_type_id: enterprise_type_id !== undefined ? enterprise_type_id : '',
    })
    updateState({
      filter: {
        project_id,
        entrepreneur_id,
        status,
        field_id,
        license_number,
        license_type_id,
        enterprise_type_id,
        enterprise_id,
        description,
        renovation_protocol,
        issue_date,
        issue_date_between,
        expiration_date,
        expiration_date_between,
        limit_renovation,
        limit_renovation_between,
      },
      ...initialQueryState,
    })
    // setTimeout(() => {
    //   setFilterLocal(false)
    // }, 5000)
  }

  const openFilter = () => {
    if (openFilterWin === false) {
      setOpenFilterWin(true)
    } else {
      setOpenFilterWin(false)
    }
  }

  const openDLimit = () => {
    if (openDatelimit === false) {
      setOpenDatelimit(true)
    } else {
      setOpenDatelimit(false)
    }
  }

  const openDExp = () => {
    if (openDateexp === false) {
      setOpenDateexp(true)
    } else {
      setOpenDateexp(false)
    }
  }

  const openDEmi = () => {
    if (openDateemi === false) {
      setOpenDateemi(true)
    } else {
      setOpenDateemi(false)
    }
  }

  const loadOptionsProjects = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getProjects()
      let projects: any = []

      async function getProjects() {
        const {data} = await axios.get(API_URL + '/v1/projects/select2')
        let Response = data.results

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const project: any = {
              value: Response[i].id,
              label: Response[i].code + ' - ' + Response[i].description,
            }
            projects.push(project)
          }
        }
        setprojectArray(projects)
      }
      callback(projects)
    }, 1000)
  }

  //função que altera o valor no AsyncSelect
  const handleChangeProjects = (option: any) => {
    setproject_id(option.value)
    setproject_obj(option)
  }

  const loadOptionsEnterprises_Types = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getEnterprises_Types()
      var enterprises: any = []
      async function getEnterprises_Types() {
        const {data} = await axios.get(API_URL + '/v1/enterprise_types/select2')
        let Response = data.results

        for (var i = 0; i < Response.length; i++) {
          const enterprise: any = {
            value: Response[i].id,
            label: Response[i].name,
          }

          enterprises.push(enterprise)
        }
      }
      setenterpriseTypeArray(enterprises)
      callback(enterprises)
    }, 1000)
  }

  //função que altera o valor no AsyncSelect
  const handleChangeEnterprises_Types = (option: any) => {
    setenterprise_type_id(option.value)
    setenterprise_type_id_obj(option)
  }

  const loadOptionsLicenses_Types = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getLicenses_Types()
      var licensesType: any = []
      async function getLicenses_Types() {
        const {data} = await axios.get(API_URL + '/sga/v1/license_types/select2')
        let Response = data.results

        for (var i = 0; i < Response.length; i++) {
          const license: any = {
            value: Response[i].id,
            label: Response[i].abbreviate,
          }

          licensesType.push(license)
        }
      }
      callback(licensesType)
    }, 1000)
  }
  //função que altera o valor no AsyncSelect
  const handleChangeLicenses_Types = (option: any) => {
    setlicense_type_id(option.value)
    setlicense_type_id_obj(option)
  }

  const loadOptionsEntrepreneurs = (
    inputValue: string,
    callback: (options: UseOption[]) => void
  ) => {
    setTimeout(() => {
      getentrepreneur()
      var entrepreneur: any = []
      async function getentrepreneur() {
        const {data} = await axios.get(API_URL + '/v1/entrepreneurs/select2')
        let Response = data.results

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const field: any = {
              value: Response[i].id,
              label: Response[i].name,
            }

            entrepreneur.push(field)
          }
        }
      }
      setentrepreneurArray(entrepreneur)
      callback(entrepreneur)
    }, 1000)
  }

  //função que altera o valor no AsyncSelect
  const handleChangeEntrepreneurs = (option: any) => {
    setentrepreneur_id(option.value)
    setentrepreneur_id_obj(option)
  }

  const loadOptionsFields = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getFields()
      var fields: any = []
      async function getFields() {
        const {data} = await axios.get(API_URL + '/v1/fields/select2')
        let Response = data.results

        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const field: any = {
              value: Response[i].id,
              label: Response[i].name,
            }

            fields.push(field)
          }
        }
      }
      callback(fields)
    }, 1000)
  }

  //função que altera o valor no AsyncSelect
  const handleChangeFields = (option: any) => {
    setfield_id(option.value)
    setfield_id_obj(option)
  }

  const loadOptionsEnterprises = (inputValue: string, callback: (options: UseOption[]) => void) => {
    setTimeout(() => {
      getenterprises()
      var enterprises: any = []
      async function getenterprises() {
        const {data} = await axios.get(API_URL + '/v1/enterprises/select2')
        let Response = data.results
        if (Response) {
          for (var i = 0; i < Response.length; i++) {
            const enterprise: any = {
              value: Response[i].id,
              label: Response[i].text,
            }

            enterprises.push(enterprise)
          }
        }
      }
      callback(enterprises)
    }, 1000)
  }

  //função que altera o valor no AsyncSelect
  const handleChangeEnterprises = (option: any) => {
    setenterprise_id(option.value)
    setenterprise_id_obj(option)
  }

  const setConvertDate = (e: any, type: string, period: 'start' | 'conclusion' | 'limit') => {
    switch (period) {
      case 'start': {
        if (type === 'single') {
          let DateFormate: any
          DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
          setissue_date(DateFormate)
          setissue_dateD(e)
        } else if (type === 'range') {
          let DateFormate: any = []
          if (e.length === 2) {
            DateFormate[0] = moment(new Date(e[0])).format('YYYY-MM-DD')
            DateFormate[1] = moment(new Date(e[1])).format('YYYY-MM-DD')
          }

          setissue_date_between(DateFormate)
          setissue_date_betweenD(e)
        }
        break
      }
      case 'conclusion': {
        if (type === 'single') {
          let DateFormate: any
          DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
          setexpiration_date(DateFormate)
          setexpiration_date_dateD(e)
        } else if (type === 'range') {
          let DateFormate: any = []
          if (e.length === 2) {
            DateFormate[0] = moment(new Date(e[0])).format('YYYY-MM-DD')
            DateFormate[1] = moment(new Date(e[1])).format('YYYY-MM-DD')
          }
          setexpiration_date_between(DateFormate)
          setexpiration_date_betweenD(e)
        }
        break
      }
      case 'limit': {
        if (type === 'single') {
          let DateFormate: any
          DateFormate = moment(new Date(e)).format('YYYY-MM-DD')
          setlimit_renovation(DateFormate)
          setlimit_renovationD(e)
        } else if (type === 'range') {
          let DateFormate: any = []
          if (e.length === 2) {
            DateFormate[0] = moment(new Date(e[0])).format('YYYY-MM-DD')
            DateFormate[1] = moment(new Date(e[1])).format('YYYY-MM-DD')
          }
          setlimit_renovation_between(DateFormate)
          setlimit_renovation_betweenD(e)
        }

        break
      }
    }
  }
  insertDataTime()

  return (
    <>
      <div className='card-body p-5 pb-5 mt-3 '>
        {/* INICIO LINHA FIXA DO FILTRO */}
        <div className='row'>
          <div className='col-lg-3'>
            <label className='form-label  fw-bold'>
              {intl.formatMessage({id: 'PROJECT.PROJECT_SINGLE'})}
            </label>
            <div className='d-flex align-items-center position-relative'>
              <AsyncSelect
                className='form-control form-control-solid p-0'
                data-kt-license-table-filter='project_id'
                styles={colourStyles}
                cacheOptions
                loadOptions={loadOptionsProjects}
                filterOption={(option, inputValue) =>
                  option.label
                    ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                    : false
                }
                defaultOptions
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'PROJECT.PROJECT_SINGLE'})
                }
                onChange={(e: any) => handleChangeProjects(e)}
                value={project_obj}
              />
            </div>
          </div>

          <div className='col-lg-4'>
            <label className='form-label  fw-bold'>
              {intl.formatMessage({id: 'ENTREPRENEUR.ENTREPRENEUR_SINGLE'})}
            </label>
            <div className='d-flex align-items-center position-relative'>
              <AsyncSelect
                className='form-control form-control-solid p-0'
                data-kt-license-table-filter='entrepreneur_id'
                styles={colourStyles}
                cacheOptions
                loadOptions={loadOptionsEntrepreneurs}
                filterOption={(option, inputValue) =>
                  option.label
                    ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                    : false
                }
                defaultOptions
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'ENTREPRENEUR.ENTREPRENEUR_SINGLE'})
                }
                onChange={(e: any) => handleChangeEntrepreneurs(e)}
                value={entrepreneur_id_obj}
              />
            </div>
          </div>

          <div className='col-lg-5'>
            <label className='form-label  fw-bold'>
              {intl.formatMessage({id: 'ENTERPRISE_TYPE.ENTERPRISE_TYPE_PLURAL'})}
            </label>
            <div className='d-flex align-items-center position-relative'>
              <AsyncSelect
                className='form-control form-control-solid p-0'
                data-kt-license-table-filter='enterprise_type_id'
                styles={colourStyles}
                cacheOptions
                loadOptions={loadOptionsEnterprises_Types}
                filterOption={(option, inputValue) =>
                  option.label
                    ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                    : false
                }
                defaultOptions
                placeholder={
                  intl.formatMessage({id: 'COMMON.SEARCH'}) +
                  ' ' +
                  intl.formatMessage({id: 'ENTERPRISE_TYPE.ENTERPRISE_TYPE_PLURAL'})
                }
                onChange={(e: any) => handleChangeEnterprises_Types(e)}
                value={enterprise_type_id_obj}
              />
              <button
                type='button'
                className='btn btn-sm btn-icon btn-light-primary btn-active-primary p-3 m-1'
                onClick={openFilter}
                title='Mais Filtros'
              >
                <i className='bi bi-sliders2-vertical fs-2' />
              </button>
              <button
                type='button'
                className='btn btn-sm btn-icon btn-light-danger p-3 m-1'
                onClick={resetData}
                title='Limpar Busca'
              >
                <KTSVG path='/media/icons/duotune/art/art004.svg' className='svg-icon-3' />
              </button>
              <button
                type='button'
                className='btn btn-sm btn-primary fs-9 px-3 m-1'
                onClick={filterData}
                title='Filtar'
              >
                {intl.formatMessage({id: 'COMMON.SEARCH'})}
              </button>
            </div>
          </div>
        </div>

        {/* FIM LINHA FIXA DO FILTRO */}

        {/* INICIO FILTRO RETRATIL FIXA DO FILTRO */}
        {/* LINHA 1 */}
        {openFilterWin && (
          <AnimaCima2>
            <div className='row mt-2'>
              <div className='col-lg-6'>
                <label className='form-label  fw-bold'>
                  {intl.formatMessage({id: 'ENTERPRISES.TITLE'})}
                </label>
                <div className='d-flex position-relative my-1'>
                  <AsyncSelect
                    className='form-control form-control-solid p-0'
                    data-kt-license-table-filter='enterprise_id'
                    styles={colourStyles}
                    cacheOptions
                    loadOptions={loadOptionsEnterprises}
                    filterOption={(option, inputValue) =>
                      option.label
                        ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                        : false
                    }
                    defaultOptions
                    placeholder={
                      intl.formatMessage({id: 'COMMON.SEARCH'}) +
                      ' ' +
                      intl.formatMessage({id: 'ENTERPRISES.TITLE'})
                    }
                    onChange={(e: any) => handleChangeEnterprises(e)}
                    value={enterprise_id_obj}
                  />
                </div>
              </div>

              <div className='col-lg-6'>
                <label className='form-label  fw-bold mt-1'>
                  {intl.formatMessage({id: 'ENTERPRISES.INPUT_FIELDS'})}
                </label>
                <AsyncSelect
                  className='form-control form-control-solid p-0'
                  data-kt-license-table-filter='field_id'
                  styles={colourStyles}
                  isMulti
                  components={animatedComponents}
                  cacheOptions
                  loadOptions={loadOptionsFields}
                  filterOption={(option, inputValue) =>
                    option.label
                      ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                      : false
                  }
                  defaultOptions
                  placeholder={
                    intl.formatMessage({id: 'COMMON.SEARCH'}) +
                    ' ' +
                    intl.formatMessage({id: 'ENTERPRISES.INPUT_FIELDS'})
                  }
                  onChange={(e: any) => handleChangeFields(e)}
                  value={field_id_obj}
                />
              </div>
            </div>
          </AnimaCima2>
        )}

        {/* LINHA 2 */}
        {openFilterWin && <div className='row mt-2'></div>}

        {/* LINHA 3 */}
        {openFilterWin && (
          <AnimaCima2>
            <div className='row mt-2'>
              <div className='col-lg-6'>
                <label className='form-label  fw-bold'>
                  {intl.formatMessage({id: 'LICENSES.TYPE'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <AsyncSelect
                    className='form-control form-control-solid p-0'
                    data-kt-license-table-filter='entrepreneur_id'
                    styles={colourStyles}
                    cacheOptions
                    loadOptions={loadOptionsLicenses_Types}
                    filterOption={(option, inputValue) =>
                      option.label
                        ? option.label.toLowerCase().indexOf(inputValue.toLowerCase()) >= 0
                        : false
                    }
                    defaultOptions
                    placeholder={
                      intl.formatMessage({id: 'COMMON.SEARCH'}) +
                      ' ' +
                      intl.formatMessage({id: 'LICENSES.TYPE'})
                    }
                    onChange={(e: any) => handleChangeLicenses_Types(e)}
                    value={license_type_id_obj}
                  />
                </div>
              </div>

              <div className='col-lg-6'>
                <label className='form-label  fw-bold'>
                  {intl.formatMessage({id: 'COMMON.STATUS'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <select
                    className='form-control form-control-solid  ps-6'
                    data-kt-select2='true'
                    data-kt-user-table-filter='status'
                    onChange={(e) => setstatus(e.target.value)}
                    value={status}
                    defaultValue='all_relevant'
                  >
                    <option value='all_relevant'>Todos Revantes</option>
                    <option value='valid'>Documento Válido</option>
                    <option value='waiting_license'>Aguardando Licença</option>
                    <option value='in_renovation'>Documento em Renovação</option>
                    <option value='renewed_replaced'>Documento Renovado/Substituído</option>
                    <option value='finished'>Documento Finalizado</option>
                    <option value='expired'>Documento Vencido</option>
                    <option value='changed_ownership'>Titularidade Alterada</option>
                    <option value='waiting_documentation'>Aguardando Documentação</option>
                    <option value='all'>Todos</option>
                  </select>
                </div>
              </div>
            </div>
          </AnimaCima2>
        )}

        {/* LINHA 4 */}

        {openFilterWin && (
          <AnimaCima2>
            <div className='row mt-2'>
              {openDateemi === false && (
                <div className='col-lg-4'>
                  <label className='form-label  fw-bold'>
                    {intl.formatMessage({id: 'COMMON.START_DATE'})}
                  </label>
                  <div className='d-flex align-items-center position-relative my-1'>
                    <Calendar
                      data-kt-user-table-filter='start_date'
                      value={issue_dateD}
                      onChange={(e) => setConvertDate(e.value, 'single', 'start')}
                      selectionMode='single'
                      inputClassName='form-control form-control-calendar form-control-solid fs-7 ps-6 border border-white'
                      style={{
                        width: '100%',
                      }}
                      dateFormat='dd/mm/yy'
                      placeholder='dd/mm/aa'
                      showButtonBar
                    />
                    <button
                      type='button'
                      className='btn btn-sm btn-icon btn-primary m-1'
                      onClick={openDEmi}
                      title='selecionar intervalo'
                    >
                      <KTSVG
                        path='/media/icons/duotune//general/gen019.svg'
                        className='svg-icon-2 svg-icon-light'
                      />
                    </button>
                  </div>
                </div>
              )}

              {openDateemi === true && (
                <div className='col-lg-4'>
                  <label className='form-label  fw-bold'>
                    {intl.formatMessage({id: 'COMMON.START_DATE'})}
                  </label>
                  <div className='d-flex align-items-center position-relative my-1'>
                    <Calendar
                      data-kt-user-table-filter='start_date'
                      value={issue_date_betweenD}
                      onChange={(e) => setConvertDate(e.value, 'range', 'start')}
                      selectionMode='range'
                      inputClassName='form-control form-control-calendar form-control-solid fs-7 ps-6 border border-white'
                      style={{
                        width: '100%',
                      }}
                      dateFormat='dd/mm/yy'
                      placeholder='dd/mm/aa - dd/mm/aa'
                      showButtonBar
                    />
                    <button
                      type='button'
                      className='btn btn-sm btn-icon btn-primary m-1'
                      onClick={openDEmi}
                      title='selecionar intervalo'
                    >
                      <KTSVG
                        path='/media/icons/duotune//general/gen019.svg'
                        className='svg-icon-2 svg-icon-light'
                      />
                    </button>
                  </div>
                </div>
              )}

              {openDateexp === false && (
                <div className='col-lg-4'>
                  <label className='form-label  fw-bold'>
                    {intl.formatMessage({id: 'COMMON.CONCLUSION_DATE'})}
                  </label>
                  <div className='d-flex align-items-center position-relative my-1'>
                    <Calendar
                      data-kt-user-table-filter='expiration_date_dateD'
                      value={expiration_date_dateD}
                      onChange={(e) => setConvertDate(e.value, 'single', 'conclusion')}
                      selectionMode='single'
                      inputClassName='form-control form-control-calendar form-control-solid fs-7 ps-6 border border-white'
                      style={{
                        width: '100%',
                      }}
                      dateFormat='dd/mm/yy'
                      placeholder='dd/mm/aa'
                      showButtonBar
                    />
                    <button
                      type='button'
                      className='btn btn-sm btn-icon btn-primary m-1'
                      onClick={openDExp}
                      title='selecionar intervalo'
                    >
                      <KTSVG
                        path='/media/icons/duotune//general/gen019.svg'
                        className='svg-icon-2 svg-icon-light'
                      />
                    </button>
                  </div>
                </div>
              )}

              {openDateexp === true && (
                <div className='col-lg-4'>
                  <label className='form-label  fw-bold'>
                    {intl.formatMessage({id: 'COMMON.CONCLUSION_DATE'})}
                  </label>
                  <div className='d-flex align-items-center position-relative my-1'>
                    <Calendar
                      data-kt-user-table-filter='expiration_date_betweenD'
                      value={expiration_date_betweenD}
                      onChange={(e) => setConvertDate(e.value, 'range', 'conclusion')}
                      selectionMode='range'
                      inputClassName='form-control form-control-calendar form-control-solid fs-7 ps-6 border border-white'
                      style={{
                        width: '100%',
                      }}
                      dateFormat='dd/mm/yy'
                      placeholder='dd/mm/aa - dd/mm/aa'
                      showButtonBar
                    />

                    <button
                      type='button'
                      className='btn btn-sm btn-icon btn-primary m-1'
                      onClick={openDExp}
                      title='selecionar intervalo'
                    >
                      <KTSVG
                        path='/media/icons/duotune//general/gen019.svg'
                        className='svg-icon-2 svg-icon-light'
                      />
                    </button>
                  </div>
                </div>
              )}

              {openDatelimit === false && (
                <div className='col-lg-4'>
                  <label className='form-label  fw-bold'>
                    {intl.formatMessage({id: 'COMMON.LIMIT_DATE'})}
                  </label>
                  <div className='d-flex align-items-center position-relative my-1'>
                    <Calendar
                      data-kt-user-table-filter='limit_renovationD'
                      value={limit_renovationD}
                      onChange={(e) => setConvertDate(e.value, 'single', 'limit')}
                      selectionMode='single'
                      inputClassName='form-control form-control-calendar form-control-solid fs-7 ps-6 border border-white'
                      style={{
                        width: '100%',
                      }}
                      dateFormat='dd/mm/yy'
                      placeholder='dd/mm/aa'
                    />
                    <button
                      type='button'
                      className='btn btn-sm btn-icon btn-primary m-1'
                      onClick={openDLimit}
                      title='selecionar intervalo'
                    >
                      <KTSVG
                        path='/media/icons/duotune//general/gen019.svg'
                        className='svg-icon-2 svg-icon-light'
                      />
                    </button>
                  </div>
                </div>
              )}

              {openDatelimit === true && (
                <div className='col-lg-4'>
                  <label className='form-label  fw-bold'>
                    {intl.formatMessage({id: 'COMMON.LIMIT_DATE'})}
                  </label>
                  <div className='d-flex align-items-center position-relative my-1'>
                    <Calendar
                      data-kt-user-table-filter='limit_renovation_betweenD'
                      value={limit_renovation_betweenD}
                      onChange={(e) => setConvertDate(e.value, 'range', 'limit')}
                      selectionMode='range'
                      inputClassName='form-control form-control-calendar form-control-solid fs-7 ps-6 border border-white'
                      style={{
                        width: '100%',
                      }}
                      dateFormat='dd/mm/yy'
                      placeholder='dd/mm/aa - dd/mm/aa'
                      showButtonBar
                    />
                    <button
                      type='button'
                      className='btn btn-sm btn-icon btn-primary m-1'
                      onClick={openDLimit}
                      title='mais Filtros'
                    >
                      <KTSVG
                        path='/media/icons/duotune//general/gen019.svg'
                        className='svg-icon-2 svg-icon-light'
                      />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </AnimaCima2>
        )}

        {/* LINHA 5 */}
        {openFilterWin && (
          <AnimaCima2>
            <div className='row mt-2'>
              <div className='col-lg-4'>
                <label className='form-label  fw-bold'>
                  {intl.formatMessage({id: 'COMMON.DESCRIPTION'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <input
                    type='text'
                    data-kt-user-table-filter='description'
                    className='form-control form-control-solid  ps-6'
                    placeholder={
                      intl.formatMessage({id: 'COMMON.SEARCH'}) +
                      ' ' +
                      intl.formatMessage({id: 'COMMON.DESCRIPTION'})
                    }
                    value={description}
                    onChange={(e: any) => setdescription(e.target.value)}
                  />
                </div>
              </div>
              <div className='col-lg-4'>
                <label className='form-label  fw-bold'>
                  {intl.formatMessage({id: 'LICENSES.NUMBER'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <input
                    type='text'
                    data-kt-user-table-filter='license_number'
                    className='form-control form-control-solid  ps-6'
                    placeholder={
                      intl.formatMessage({id: 'COMMON.SEARCH'}) +
                      ' ' +
                      intl.formatMessage({id: 'LICENSES.NUMBER'})
                    }
                    value={license_number}
                    onChange={(e) => setlicense_number(e.target.value)}
                  />
                </div>
              </div>

              <div className='col-lg-4'>
                <label className='form-label  fw-bold'>
                  {intl.formatMessage({id: 'LICENSE_RENEWAL_PROTOCOL'})}
                </label>
                <div className='d-flex align-items-center position-relative my-1'>
                  <input
                    type='text'
                    data-kt-user-table-filter='renovation_protocol'
                    className='form-control form-control-solid  ps-6'
                    placeholder={
                      intl.formatMessage({id: 'COMMON.SEARCH'}) +
                      ' ' +
                      intl.formatMessage({id: 'LICENSE_RENEWAL_PROTOCOL'})
                    }
                    value={renovation_protocol}
                    onChange={(e) => setrenovation_protocol(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </AnimaCima2>
        )}
      </div>
    </>
  )
}

export {LicensesListFilter}
